import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from "buffer";
import process from "process";
import "@/index.css";
import App from "@/App";

// ─────────────────────────────────────────────────────────────────────────────
// iOS Safari / Capacitor WebView polyfills — JS bundle redundancy on top
// of the inline <script> in index.html.
//
// Old WebKit (iOS 14-16) throws ReferenceError: "no global object" when
// bundled libs (jsPDF, exceljs, etc.) reference `global` at load time.
// Same for `Buffer` and `process`, which a handful of Node-targeted libs
// reach for via UMD wrappers. We define all 4 here BEFORE any other
// import-time code runs (React.createRoot is the very next statement).
// ─────────────────────────────────────────────────────────────────────────────
if (typeof window !== "undefined") {
  if (typeof window.global === "undefined") window.global = window;
  if (typeof window.globalThis === "undefined") window.globalThis = window;
  if (typeof window.Buffer === "undefined") window.Buffer = Buffer;
  if (typeof window.process === "undefined") window.process = process;
}
if (typeof globalThis !== "undefined" && typeof globalThis.global === "undefined") {
  globalThis.global = globalThis;
}

// ─────────────────────────────────────────────────────────────────────────────
// Fix: restore a native, unwrapped window.fetch before React mounts.
//
// PostHog session-recording (loaded from index.html) wraps window.fetch and
// consumes the response body for tracking, leaving every Response with
// bodyUsed:true. That breaks `response.text()`, `.json()`, and even `.clone()`
// across the entire app — most visibly on the Login screen as
// "Failed to execute 'text' on 'Response': body stream already read".
//
// We grab a fresh fetch from a throwaway iframe (whose window is a clean
// realm not yet touched by any analytics wrapper) and bind it to our window.
// Done synchronously, exactly once, before any of our code makes a request.
// ─────────────────────────────────────────────────────────────────────────────
(function restoreNativeFetch() {
  try {
    if (typeof document === "undefined") return;
    const sandbox = document.createElement("iframe");
    sandbox.setAttribute("aria-hidden", "true");
    sandbox.style.display = "none";
    (document.documentElement || document.body).appendChild(sandbox);
    const nativeFetch = sandbox.contentWindow && sandbox.contentWindow.fetch;
    if (typeof nativeFetch === "function") {
      window.fetch = nativeFetch.bind(window);
    }
    sandbox.parentNode.removeChild(sandbox);
  } catch (_) {
    // If anything goes wrong, fall back to the existing (possibly wrapped)
    // fetch — the app keeps working for non-error responses.
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
